import logo from './logo.png'
import loading from './loading.png'
import page1Bg from './page1-bg.png'
import logoWhite from './logo-white.png'
import page1Image0 from './page1-image0.png'
import introduction0 from './introduction0.png'
import introduction1 from './introduction1.png'
import introduction2 from './introduction2.png'
import introduction3 from './introduction3.png'
import introduction4 from './introduction4.png'
import introduction5 from './introduction5.png'
import introduction6 from './introduction6.png'
import introduction7 from './introduction7.png'
import channelBg from './channel-bg.png'
import tools00 from './tools0-0.png'
import tools01 from './tools0-1.png'
import tools10 from './tools1-0.png'
import tools11 from './tools1-1.png'
import tools20 from './tools2-0.png'
import tools21 from './tools2-1.png'
import tools30 from './tools3-0.png'
import tools31 from './tools3-1.png'
import tools40 from './tools4-0.png'
import tools41 from './tools4-1.png'
import tools50 from './tools5-0.png'
import tools51 from './tools5-1.png'
import main from './multi-device-main.png'
import lifeStyle0 from './life-style0.png'
import lifeStyle1 from './life-style1.png'
import lifeStyle2 from './life-style2.png'
import lifeStyle3 from './life-style3.png'
import lifeStyle4 from './life-style4.png'
import lifeStyle5 from './life-style5.png'
import lifeStyle6 from './life-style6.png'
import lifeStyle7 from './life-style7.png'
import lifeProposal0 from './life-proposal0.png'
import lifeProposal1 from './life-proposal1.png'
import lifeProposal2 from './life-proposal2.png'
import lifeProposal3 from './life-proposal3.png'
import lifeProposal4 from './life-proposal4.png'
import lifeProposal5 from './life-proposal5.png'
import lifeProposal6 from './life-proposal6.png'
import lifeProposal7 from './life-proposal7.png'
import bigScreen from './big-screen.png'
import feedback from './feedback.png'
import left from './left.png'
import right from './right.png'
import experienceApplicationImport from './experience-application-import.png'
import experienceApplicationBtn from './experience-application-btn.png'
import bgIcon0 from './bg-icon0.png'
import bgIcon1 from './bg-icon1.png'
import bgIcon2 from './bg-icon2.png'
import packagesListTitle0 from './packages-list-title0.png'
import packagesListTitle1 from './packages-list-title1.png'
import packagesListTitle2 from './packages-list-title2.png'
import add from './add.png'
import a0 from './a0.png'
import a1 from './a1.png'
import a2 from './a2.png'
import b0 from './b0.png'
import b1 from './b1.png'
import b2 from './b2.png'
import payment0 from './payment0.png'
import payment1 from './payment1.png'
import footerBg from './footer-bg.png'
import icon00 from './icon0-0.png'
import icon01 from './icon0-1.png'
import icon10 from './icon1-0.png'
import icon11 from './icon1-1.png'
import icon20 from './icon2-0.png'
import icon21 from './icon2-1.png'
import wechatAdd from './wechat-add.png'
import backTop from './back-top.png'
export default {
    logo,
    loading,
    page1Bg,
    logoWhite,
    page1Image0,
    introduction0,
    introduction1,
    introduction2,
    introduction3,
    introduction4,
    introduction5,
    introduction6,
    introduction7,
    channelBg,
    tools00,
    tools01,
    tools10,
    tools11,
    tools20,
    tools21,
    tools30,
    tools31,
    tools40,
    tools41,
    tools50,
    tools51,
    main,
    lifeStyle0,
    lifeStyle1,
    lifeStyle2,
    lifeStyle3,
    lifeStyle4,
    lifeStyle5,
    lifeStyle6,
    lifeStyle7,
    lifeProposal0,
    lifeProposal1,
    lifeProposal2,
    lifeProposal3,
    lifeProposal4,
    lifeProposal5,
    lifeProposal6,
    lifeProposal7,
    bigScreen,
    feedback,
    left,
    right,
    experienceApplicationImport,
    experienceApplicationBtn,
    bgIcon0,
    bgIcon1,
    bgIcon2,
    packagesListTitle0,
    packagesListTitle1,
    packagesListTitle2,
    add,
    a0,
    a1,
    a2,
    b0,
    b1,
    b2,
    payment0,
    payment1,
    footerBg,
    icon00,
    icon01,
    icon10,
    icon11,
    icon20,
    icon21,
    wechatAdd,
    backTop
}